/** Company product entitlements. Exact backend strings — do not rename. */
export const FEATURE = {
    RETAINER_TEMPLATES: 'RETAINER_TEMPLATES',
    CLIENT_ENGAGEMENT: 'CLIENT_ENGAGEMENT',
    PARTNER_ORGANIZATIONS: 'PARTNER_ORGANIZATIONS',
    FINANCIALS: 'FINANCIALS',
    REPLY_SUGGESTIONS: 'REPLY_SUGGESTIONS',
    /** Default when `/me` carries no RETAINER_FLOW_*; keeps the PDF retainer UI. */
    RETAINER_FLOW_LEGACY_SERVICED_OR_NON_SERVICED: 'RETAINER_FLOW_LEGACY_SERVICED_OR_NON_SERVICED',
    RETAINER_FLOW_TWO_STAGE_SERVICE_THEN_CONSULTANT_SERVICED_AGREEMENT:
        'RETAINER_FLOW_TWO_STAGE_SERVICE_THEN_CONSULTANT_SERVICED_AGREEMENT',
    RETAINER_FLOW_SERVICED_OR_NON_SERVICED: 'RETAINER_FLOW_SERVICED_OR_NON_SERVICED',
    RETAINER_FLOW_FREE: 'RETAINER_FLOW_FREE',
} as const;

export type FeatureName = (typeof FEATURE)[keyof typeof FEATURE];
